module.exports = __webpack_public_path__ + "static/zmigrod_main_1-e4247ee0b0867687bb63c53d7c02c120.png";